import { formatCurrency } from "../pages/dashboardUtils";

export default function PriceHistoryChart({
  points,
  t,
  height = 160,
  stroke = "#ef4444",
  fill = "rgba(239,68,68,0.12)",
  background = "#fff7ed",
}) {
  const safePoints = (points || []).filter((point) =>
    Number.isFinite(Number(point?.price))
  );

  if (safePoints.length < 2) {
    return (
      <div
        style={{
          minHeight: height,
          borderRadius: 18,
          border: "1px dashed #fdba74",
          background,
          color: "#9a3412",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 18,
          textAlign: "center",
        }}
      >
        {t?.("chart.need_more", "Adicione mais leituras para o grafico ganhar forma.") ||
          "Adicione mais leituras para o grafico ganhar forma."}
      </div>
    );
  }

  const prices = safePoints.map((point) => Number(point.price));
  const maxValue = Math.max(...prices);
  const minValue = Math.min(...prices);
  const range = Math.max(maxValue - minValue, 1);
  const width = 100;

  const linePoints = safePoints
    .map((point, index) => {
      const x = safePoints.length === 1 ? width / 2 : (index / (safePoints.length - 1)) * width;
      const y = 100 - ((Number(point.price) - minValue) / range) * 84 - 8;
      return `${x},${y}`;
    })
    .join(" ");

  const areaPoints = `0,100 ${linePoints} 100,100`;

  return (
    <div
      style={{
        padding: 16,
        borderRadius: 20,
        border: "1px solid #fed7aa",
        background,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
        <div>
          <div style={{ fontSize: 12, fontWeight: 800, color: "#9a3412", textTransform: "uppercase" }}>
            {t?.("chart.title", "Linha de inflacao") || "Linha de inflacao"}
          </div>
          <div style={{ marginTop: 6, color: "#475569" }}>
            {formatCurrency(minValue)} a {formatCurrency(maxValue)}
          </div>
        </div>
        <div style={{ color: "#64748b", fontSize: 13 }}>
          {(t?.("chart.readings", "{{count}} leituras") || "{{count}} leituras").replace(
            "{{count}}",
            String(safePoints.length)
          )}
        </div>
      </div>

      <svg
        viewBox={`0 0 ${width} 100`}
        preserveAspectRatio="none"
        style={{ width: "100%", height, marginTop: 14, display: "block" }}
      >
        <defs>
        <linearGradient id="pennypantry-chart-fill" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor={fill} />
            <stop offset="100%" stopColor="rgba(255,255,255,0)" />
          </linearGradient>
        </defs>
        <path d={`M ${areaPoints.replace(/ /g, " L ")}`} fill="url(#pennypantry-chart-fill)" />
        <polyline
          fill="none"
          stroke={stroke}
          strokeWidth="2.6"
          strokeLinejoin="round"
          strokeLinecap="round"
          points={linePoints}
        />
        {safePoints.map((point, index) => {
          const x = safePoints.length === 1 ? width / 2 : (index / (safePoints.length - 1)) * width;
          const y = 100 - ((Number(point.price) - minValue) / range) * 84 - 8;
          return (
            <circle
              key={`${point.price}-${point.captured_at || index}`}
              cx={x}
              cy={y}
              r="2.4"
              fill="#ffffff"
              stroke={stroke}
              strokeWidth="1.6"
            />
          );
        })}
      </svg>
    </div>
  );
}
